import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default C => props => {
    const { t } = useTranslation();
    const authentication = useSelector(state => state.authentication);
    return authentication.account ? (
        <C {...props} />
    ) : authentication.isLoggingIn === undefined ? null : (
        <h1>{t("Authentication.defaultText")}</h1>
    );
};
